import { useInsiderMembershipInformation } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderMembershipInformation";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import addDays from "date-fns/addDays";
export var DEFAULT_INSIDER_TRAILING_PERIOD_DAYS = 30;
var ONE_MONTH_IN_DAYS = 30;
/**
 * A hook that provides trialing period related information for Insider Membership.
 *
 * This hook returns an object that provides the number of eligible trialing period days, months, and when the trialing period will end.
 * It relies on the `useInsiderMembershipInformation` hook to fetch the relevant information.
 *
 * @returns {IUseInsiderTrialingPeriodResult} An object containing Insider Membership trialing period related information.
 */ export function useInsiderTrialingPeriod() {
    var insiderMembershipInformation = useInsiderMembershipInformation().insiderMembershipInformation;
    var _insiderMembershipInformation_trialing_period_days;
    var trialingPeriodDays = (_insiderMembershipInformation_trialing_period_days = insiderMembershipInformation === null || insiderMembershipInformation === void 0 ? void 0 : insiderMembershipInformation.trialing_period_days) !== null && _insiderMembershipInformation_trialing_period_days !== void 0 ? _insiderMembershipInformation_trialing_period_days : DEFAULT_INSIDER_TRAILING_PERIOD_DAYS;
    var trialingPeriodMonths = Math.trunc(trialingPeriodDays / ONE_MONTH_IN_DAYS);
    var trialingPeriodUntil = intlDate(addDays(new Date(), trialingPeriodDays), "PP");
    return {
        trialingPeriodDays: trialingPeriodDays,
        trialingPeriodMonths: trialingPeriodMonths,
        trialingPeriodUntil: trialingPeriodUntil
    };
}
